import { render } from "./TopNavbar.vue?vue&type=template&id=08ba7328"
const script = {}

import exportComponent from "C:\\Users\\gjf1611\\code\\private\\planet-c\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__